export const REPOSITION_DESKTOP_ICON:'REPOSITION_DESKTOP_ICON' = 'REPOSITION_DESKTOP_ICON';